import { render } from "./Index.vue?vue&type=template&id=6e160c72&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6e160c72"

export default script